export function ensureNCALayerConnected({ connectTimeoutMs = 1200 } = {}) {
  return new Promise((resolve) => {
    if (!window.NCA?.connect || !window.NCA?.getState) return resolve(false);

    let done = false;
    const finish = (ok) => {
      if (done) return;
      done = true;
      resolve(ok);
    };

    const hasSignFn = () =>
      typeof window.NCA?.createCMSSignatureFromBase64 === "function" ||
      typeof window.createCMSSignatureFromBase64 === "function"; // если оставишь алиас

    const handler = (e) => {
      const st = e.detail;
      if (st.connected) {
        window.removeEventListener("ncalayer-status", handler);
        finish(hasSignFn()); // 👈 важно
      }
    };

    window.addEventListener("ncalayer-status", handler);
    window.NCA.connect({ silent: true });

    setTimeout(() => {
      window.removeEventListener("ncalayer-status", handler);
      const st = window.NCA.getState();
      finish(!!st.connected && hasSignFn()); // 👈 важно
    }, connectTimeoutMs);
  });
}
